module.exports = __webpack_public_path__ + "static/media/blog-33-image-2.a2a194a3.webp";